"use client"

import type React from "react"

import { useState } from "react"
import { Container, Box, Typography, Paper, Tabs, Tab } from "@mui/material"
import { ThemeProvider } from "./components/theme-provider"
import ParticipantList from "./components/participant-list"
import SubmissionList from "./components/submission-list"
import UnSubmittedParticipant from "./components/unsubmitted-participant"
import SendMailComponent from "./components/sendmail-participant"
import AlertForm from "./components/alert"

export default function Dashboard() {
  const [activeTab, setActiveTab] = useState(0)

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
  }

  return (
    <ThemeProvider>
      <Container maxWidth="lg">
        <Box sx={{ my: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Participant and Submission Management System
          </Typography>
          <Paper sx={{ width: "100%", mb: 2 }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              <Tab label="Participant List" />
              {/* <Tab label="Unsubmitted Participants" /> */}
              <Tab label="Submitted Participants" />
              <Tab label="Send mail to participants" />
              <Tab label="Alert" />
            </Tabs>

            <Box sx={{ p: 3 }}>
              {activeTab === 0 && <ParticipantList />}
              {activeTab === 1 && <SubmissionList />}
              {activeTab === 2 && <SendMailComponent />}
              {activeTab === 3 && <AlertForm />}
            </Box>
          </Paper>
        </Box>
      </Container>
    </ThemeProvider>
  )
}
